// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__nO5Eu","versus":"styles_versus__f7A5D","logo":"styles_logo__x2G3_"};